const NotFoundPage = () => {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-lg text-gray-600">Page not found.</p>
        <a
          href="/"
          className="mt-4 inline-block px-4 py-2 bg-secondary text-white rounded hover:bg-secondary-dark transition"
        >
          Go Home
        </a>
      </div>
    );
  };

  export default NotFoundPage;